export default "__VITE_ASSET__Dcy3Qpe2__"